import '../../../node_modules/ui-core/widgets/search-result/js/search-result';

(function () {
    const searchResult = UX.searchResult;
    searchResult.additionalControl = () => {
        $('body').on('click', '.search__header .advanced-search__ctrl', function (e) {
            e.preventDefault();
            $(this).toggleClass('js--open');
            $('.search__header .advanced-search__tabs').slideToggle('fast');
        });
    };
})();
